import { render, staticRenderFns } from "./instagram-list-item.vue?vue&type=template&id=3f30c4d6&scoped=true&"
import script from "./instagram-list-item.vue?vue&type=script&lang=js&"
export * from "./instagram-list-item.vue?vue&type=script&lang=js&"
import style0 from "./instagram-list-item.vue?vue&type=style&index=0&id=3f30c4d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f30c4d6",
  null
  
)

export default component.exports